import React from "react"
import { globalStyles } from "../../styles"
import { Global } from "@emotion/react"
import TransitionCurtain from "../../components/TransitionCurtain/TransitionCurtain";
import ConsentBanner from "../../components/ConsentBanner"

const CustomLayout = ({ element, props }) => {
  return (
    <>
      <Global styles={globalStyles} />
      <TransitionCurtain {...props}>{element}</TransitionCurtain>
      <ConsentBanner />
    </>
  )
}

export default CustomLayout